import { withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-4",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = {
  key: 1,
  class: "w-4",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.41107 4.41058C4.73651 4.08514 5.26414 4.08514 5.58958 4.41058L10.0003 8.82133L14.4111 4.41058C14.7365 4.08514 15.2641 4.08514 15.5896 4.41058C15.915 4.73602 15.915 5.26366 15.5896 5.58909L11.1788 9.99984L15.5896 14.4106C15.915 14.736 15.915 15.2637 15.5896 15.5891C15.2641 15.9145 14.7365 15.9145 14.4111 15.5891L10.0003 11.1783L5.58958 15.5891C5.26414 15.9145 4.73651 15.9145 4.41107 15.5891C4.08563 15.2637 4.08563 14.736 4.41107 14.4106L8.82181 9.99984L4.41107 5.58909C4.08563 5.26366 4.08563 4.73602 4.41107 4.41058Z",
    fill: "#B82025"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: `inline-block relative ${_ctx.customMargin} text-12px xxl:text-14px`
  }, [
    _createVNode("input", {
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
      value: _ctx.value,
      placeholder: _ctx.placeholder,
      class: 
        `${
          _ctx.value ? 'text-black-lp-200' : 'text-gray-lp-500'
        } block appearance-none w-full bg-white border border-gray-lp-400 px-3 py-2.5 xxl:py-2.5 ${
          _ctx.isIconLeft ? 'pl-10' : 'pr-12'
        } rounded leading-tight focus:outline-none`
      ,
      onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('enter', $event)), ["enter"]))
    }, null, 42, ["value", "placeholder"]),
    _createVNode("div", {
      class: 
        `absolute inset-y-0 ${
          _ctx.isIconLeft ? 'left-0 ml-2' : 'right-0 mr-2'
        } items-center px-2 py-2`
      ,
      onClick: _cache[3] || (_cache[3] = () => (_ctx.value ? _ctx.onClear() : {}))
    }, [
      (!_ctx.value || _ctx.isIconClearRight)
        ? (_openBlock(), _createBlock("svg", _hoisted_1, [
            _createVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M10 4C8.4087 4 6.88258 4.63214 5.75736 5.75736C4.63214 6.88258 4 8.4087 4 10C4 10.7879 4.15519 11.5681 4.45672 12.2961C4.75825 13.0241 5.20021 13.6855 5.75736 14.2426C6.31451 14.7998 6.97595 15.2417 7.7039 15.5433C8.43185 15.8448 9.21207 16 10 16C10.7879 16 11.5681 15.8448 12.2961 15.5433C13.0241 15.2417 13.6855 14.7998 14.2426 14.2426C14.7998 13.6855 15.2417 13.0241 15.5433 12.2961C15.8448 11.5681 16 10.7879 16 10C16 8.4087 15.3679 6.88258 14.2426 5.75736C13.1174 4.63214 11.5913 4 10 4ZM4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 11.0506 17.7931 12.0909 17.391 13.0615C17.1172 13.7226 16.7565 14.3425 16.3196 14.9054L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9054 16.3196C14.3425 16.7565 13.7226 17.1172 13.0615 17.391C12.0909 17.7931 11.0506 18 10 18C8.94943 18 7.90914 17.7931 6.93853 17.391C5.96793 16.989 5.08601 16.3997 4.34315 15.6569C3.60028 14.914 3.011 14.0321 2.60896 13.0615C2.20693 12.0909 2 11.0506 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315Z",
              fill: _ctx.colorIcon
            }, null, 8, ["fill"])
          ]))
        : (_ctx.value && !_ctx.isIconClearRight)
          ? (_openBlock(), _createBlock("svg", _hoisted_2, [
              _createVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
                fill: _ctx.colorIcon
              }, null, 8, ["fill"])
            ]))
          : _createCommentVNode("", true)
    ], 2),
    (_ctx.value && _ctx.isIconClearRight)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: 
        `absolute inset-y-0 ${
          _ctx.isIconClearRight ? 'right-0 mr-2' : ''
        } items-center px-2 py-2`
      ,
          onClick: _cache[4] || (_cache[4] = () => (_ctx.value ? _ctx.onClear() : {}))
        }, [
          _hoisted_3
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}